/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_TitleInputs */

const en_faq_title = /** @type {(inputs: Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Before we begin.`)
};

const lv_faq_title = /** @type {(inputs: Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pirms sākam.`)
};

/**
* | output |
* | --- |
* | "Before we begin." |
*
* @param {Faq_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_title = /** @type {((inputs?: Faq_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_title(inputs)
	return en_faq_title(inputs)
});